import { onMount } from "solid-js";
import { useNavbar } from "../contexts/RootContext";

export const usePageTitle = (title: string) => {
  const { setTitle } = useNavbar();

  onMount(() => {
    setTitle(title);
  });
};
